import { render } from "./otopack-warning.vue?vue&type=template&id=aba4a9d2&scoped=true&ts=true"
import script from "./otopack-warning.vue?vue&type=script&lang=ts"
export * from "./otopack-warning.vue?vue&type=script&lang=ts"

import "./otopack-warning.vue?vue&type=style&index=0&id=aba4a9d2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aba4a9d2"]])

export default __exports__